export default __webpack_public_path__ + "static/media/add.60acbac3.svg";